module.exports = __webpack_public_path__ + "img/f16.32e934b4.png";